import { render, staticRenderFns } from "./administrativeDocumentMainView.vue?vue&type=template&id=43e6c1b0&scoped=true&"
import script from "./administrativeDocumentMainView.vue?vue&type=script&lang=js&"
export * from "./administrativeDocumentMainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e6c1b0",
  null
  
)

export default component.exports